var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitTicketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4h14c1.094 0 2 .906 2 2v1.906a.743.743 0 0 1-.5.688c-.594.219-1 .781-1 1.406 0 .656.406 1.219 1 1.438.281.093.5.374.5.687V14c0 1.125-.906 2-2 2H3c-1.125 0-2-.875-2-2v-1.875c0-.313.188-.594.5-.688.563-.218 1-.78 1-1.437 0-.625-.438-1.188-1-1.406a.703.703 0 0 1-.5-.688V6c0-1.094.875-2 2-2zm-.5 2v1.406C3.375 7.938 4 8.906 4 10c0 1.125-.625 2.094-1.5 2.625V14c0 .281.219.5.5.5h14c.25 0 .5-.219.5-.5v-1.375A3.02 3.02 0 0 1 16 10c0-1.094.594-2.063 1.5-2.594V6c0-.25-.25-.5-.5-.5H3c-.281 0-.5.25-.5.5zm11 5.5v-3h-7v3h7zM5 8c0-.531.438-1 1-1h8c.531 0 1 .469 1 1v4c0 .563-.469 1-1 1H6c-.563 0-1-.438-1-1V8z",
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitTicketIcon);
export default __webpack_public_path__ + "static/media/SubmitTicketIcon.059bae29f9feabec5be8dec1d8df5812.svg";
export { ForwardRef as ReactComponent };